import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { ToolItem } from 'src/app/modules/tools/classes/tool-item';
import { ToolsService } from 'src/app/modules/tools/services/tools.service';
import { AudioDescriptor } from 'src/app/shared/enums/audio-descriptor';
import { AudioType } from 'src/app/shared/enums/audio-type';
import { PopulationService } from 'src/app/shared/services/population/population.service';
import { ActivityService, UserService } from 'src/app/shared/services';
import { ToolID } from 'src/app/modules/tools/enums/tool-id';
import { Population } from 'src/app/shared/interfaces';

@Component({
  selector: 'htc-toolbar',
  templateUrl: './toolbar.component.html',
  styleUrls: ['./toolbar.component.scss'],
  standalone: false,
})
export class ToolbarComponent implements OnInit, OnDestroy {
  tools!: ToolItem[];
  animOut = false;
  clickDescriptor = AudioDescriptor.SELECT_MINOR;
  clickType = AudioType.audio_SfxClick;
  shouldShowReadAloudToggle = true;
  shouldDisableToolbar = false;
  filteredTools: ToolItem[] = [];
  selectedAvatar = '';
  isActivityCompleteInProgress = false;

  subscriptions = new Subscription();

  constructor(
    public toolsService: ToolsService,
    public populationService: PopulationService,
    private activityService: ActivityService,
    private userService: UserService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.subscriptions.add(
      this.populationService.currentPopulation.subscribe(population => {
        this.shouldShowReadAloudToggle = !population?.verbal;
        this.filterToolsByPopulation(population);
        this.cdr.markForCheck();
      })
    );

    this.subscriptions.add(
      this.toolsService.animOutEvent.subscribe(() => {
        this.animOut = true;
        this.cdr.markForCheck();
      })
    );

    this.subscriptions.add(
      this.toolsService.toolsChanged$.subscribe(() => {
        this.filterToolsByPopulation(
          this.populationService.currentPopulation.value
        );
        this.cdr.markForCheck();
      })
    );
    this.subscriptions.add(
      this.populationService.disableToolbar$.subscribe(disable => {
        this.shouldDisableToolbar = disable;
        this.cdr.markForCheck();
      })
    );
    this.subscriptions.add(
      this.userService.selectedAvatar.subscribe(avatar => {
        this.selectedAvatar = avatar + '.png';
        this.cdr.markForCheck();
      })
    );
    this.subscriptions.add(
      this.activityService.activitySubmitInProgress$.subscribe(isInProgress => {
        this.isActivityCompleteInProgress = isInProgress;
        this.cdr.markForCheck();
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  filterToolsByPopulation(population: Population | undefined): void {
    // TODO: AMR - POST BTS: Make the tools a BehaviourSubject and consume that from all places.
    // clearTools() replaces the service array; always take the current reference.
    this.tools = this.toolsService.getTools();
    if (population?.verbal) {
      this.filteredTools = [...this.tools];
    } else {
      // Remove the verbal on demand prompt tool if the population does not have verbal enabled.
      this.filteredTools = this.tools.filter(
        tool => tool.data.id !== ToolID.VERBAL_ON_DEMAND_PROMPT
      );
    }
  }

  shouldShowVOInProgress(tool: ToolItem): boolean | undefined {
    return (
      tool.data.id === ToolID.PREK2_VERBAL_PROMPT ||
      tool.data.id === ToolID.VERBAL_ON_DEMAND_PROMPT ||
      (tool.data.id === ToolID.ON_DEMAND_HINT &&
        this.populationService.currentPopulation.value?.verbal)
    );
  }

  get isPreK2Reading(): boolean {
    return this.activityService.isPreK2ReadingActivity();
  }

  getToolbarIcon(tool: ToolItem, isToggleIcon = false): string {
    if (tool.data.hasPK2Avatar) return this.selectedAvatar;
    else {
      if (!isToggleIcon)
        return this.toolsService.iconMap.get(tool.data.id) ?? tool.data.icon;
      else return tool.data.toggledIcon || '';
    }
  }
}
